import basketActions from "./redux/basket/actions";
import { connect, useDispatch } from "react-redux";
import db, { auth as Auth } from "./firebase";
import "./App.css";
import Leftnav from "./components/Leftnav";
import Notifications, { notify } from "react-notify-toast";

import { Redirect, Route, Switch } from "react-router-dom";

import Load from "./roles/load";
import { useEffect, useState } from "react";
import NotificationBar from "./pages/NotificationBar";

function App() {
  const [user, setuser] = useState(JSON.parse(localStorage.getItem("Ubytes")));
  const [notification, setnotification] = useState("");
  const notifUpdate = async (id) => {
    await db.collection("notifications").doc(id).update({ seen: true });
  };
  useEffect(() => {
    if (user) {
      if (user.role === "Branch") {
        setInterval(async () => {
          let notification = await db
            .collection("notifications")
            .where("for", "==", user.branchId)
            .get();
          notification.forEach((notif) => {
            if (!notif.data().seen) {
              notify.show(
                notif.data().title + "\n" + notif.data().message,
                "success",
                5000
              );
              notifUpdate(notif.id);
            }
          });
        }, 5000);
      }
    }
  }, [notification]);
  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
      <Leftnav></Leftnav>
      <Notifications></Notifications>
      {/* <NotificationBar></NotificationBar>*/}
      <Switch>
        <Route path="/" component={Load}></Route>
      </Switch>
    </div>
  );
}

export default App;
